import { Link, router, usePage } from '@inertiajs/react'
import { Clapperboard, Drama, LogOut } from 'lucide-react'
import type { ReactNode } from 'react'
import { FlashToaster } from '@/components/flash-toaster'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarInset,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar'
import { TooltipProvider } from '@/components/ui/tooltip'
import { adminProductions, sessions } from '@/routes'

const NAV = [{ label: 'Productions', route: adminProductions.index(), icon: Clapperboard }]

export default function AdminLayout({ children }: { children: ReactNode }) {
  const { url, props } = usePage()

  return (
    <TooltipProvider>
      <SidebarProvider>
        <Sidebar>
          <SidebarHeader>
            <Link href={adminProductions.index()} className="flex items-center gap-2 px-2 py-1.5 font-semibold">
              <Drama className="size-4" /> Scripted
            </Link>
          </SidebarHeader>
          <SidebarContent>
            <SidebarGroup>
              <SidebarMenu>
                {NAV.map((item) => (
                  <SidebarMenuItem key={item.label}>
                    <SidebarMenuButton asChild isActive={url.startsWith(item.route.url)}>
                      <Link href={item.route}>
                        <item.icon /> {item.label}
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroup>
          </SidebarContent>
          <SidebarFooter>
            <SidebarMenu>
              <SidebarMenuItem>
                <div className="truncate px-2 text-xs text-muted-foreground">{props.currentUser?.email}</div>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton onClick={() => router.visit(sessions.destroy())}>
                  <LogOut /> Sign out
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarFooter>
        </Sidebar>
        <SidebarInset>
          <header className="flex h-12 items-center gap-2 border-b px-4 md:hidden">
            <SidebarTrigger />
            <span className="font-semibold">Scripted</span>
          </header>
          <main className="mx-auto w-full max-w-6xl p-4 sm:p-6 lg:p-8">{children}</main>
        </SidebarInset>
        <FlashToaster />
      </SidebarProvider>
    </TooltipProvider>
  )
}
